export const SKINNY_REGULAR_ON_BED_SLUG_MAP: Record<string, string> = {
  old_black_skinny: 'barbara-miltwe',
  old_red_skinny: 'beatrice-viqros',
  old_brunette_skinny: 'becky-9fenpy',
  old_blonde_regular: 'bella-sgjuuy',
  old_blonde_skinny: 'betty-ufrzee',
  old_black_regular: 'bianca-vcnn0k',
  old_red_regular: 'bonnie-bmj4cs',
  old_brunette_regular: 'brianna-gdufrw',
  old_brunette_athletic: 'lacey-k42bnt',
  old_black_athletic: 'leah-p8uqhm',
  old_blonde_plus_size: 'lenka-fd651t',
  old_blonde_athletic: 'liana-q8ggj8',
  old_red_plus_size: 'lola-2ebq0q',
  old_black_plus_size: 'london-s3amd1',
  old_brunette_plus_size: 'luna-0v2tbs',
  old_red_athletic: 'lydia-s3r6w7',
  young_black_regular: 'margot-p5hjfs',
  young_blonde_regular: 'melanie-zproxl',
  young_red_skinny: 'nina-4fleju',
  young_brunette_skinny: 'nora-a15ooc',
  young_blonde_skinny: 'olga-dblle2',
  young_black_skinny: 'olivia-gbn4fq',
  young_red_regular: 'pamela-or9xbb',
  young_brunette_regular: 'penny-ycerpg',
  young_blonde_plus_size: 'sabrina-abi0tj',
  young_brunette_plus_size: 'samantha-ahvlne',
  young_black_athletic: 'sasha-p6vx37',
  young_red_athletic: 'selena-zg7rnb',
  young_brunette_athletic: 'serena-pif6ni',
  young_black_plus_size: 'sophie-nzh0st',
  young_blonde_athletic: 'stefania-fe0kvv',
  young_red_plus_size: 'summer-9oqw71',
};
